import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'angular2-moment';
import { MDBBootstrapModulePro } from 'libs/mdbootstrap/typescripts/pro/index';
import { MDBBootstrapModule } from 'libs/mdbootstrap/typescripts/free/index';
import { ProcessService } from 'app/core/process/process.service';
import { CoreModule } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModalModule } from 'app/modal/modal.module';
import { EditProcessRoutingModule } from 'app/editProcess/editProcess-routing.module';
import { EditProcessComponent } from 'app/editProcess/editProcess.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MediumEditorDirectiveModule } from 'app/shared/mediumEditor/mediumEditor.module';

@NgModule({
  imports: [
    MDBBootstrapModule,
    MDBBootstrapModulePro,
    CommonModule,
    BrowserModule,
    TranslateModule,
    MomentModule,
    CoreModule,
    SharedModule,
    EditProcessRoutingModule,
    ModalModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MediumEditorDirectiveModule
  ],
  declarations: [
    EditProcessComponent
  ],
  providers: [
    ProcessService
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class EditProcessModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/editProcess/editProcess.module.ts